/**
 * @generated SignedSource<<a73bfd0c132bf1e3ab8b2ee74188086c>>
 * @relayHash 74b417d304c57976b899306f93428c4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b36c6c2510862573bc06ef4f0bdbb7bd99382b9e2118c66d79b68bfaddd9f647

import type { ConcreteRequest } from 'relay-runtime';
export type SpaceStarFavoriteSpaceMutation$variables = {
  spaceKey: string;
};
export type SpaceStarFavoriteSpaceMutation$data = {
  readonly favouriteSpace: {
    readonly isSpaceFavourited: boolean | null | undefined;
  } | null | undefined;
};
export type SpaceStarFavoriteSpaceMutation = {
  response: SpaceStarFavoriteSpaceMutation$data;
  variables: SpaceStarFavoriteSpaceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "FavouriteSpacePayload",
    "kind": "LinkedField",
    "name": "favouriteSpace",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isSpaceFavourited"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SpaceStarFavoriteSpaceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpaceStarFavoriteSpaceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "74b417d304c57976b899306f93428c4f",
    "id": "b36c6c2510862573bc06ef4f0bdbb7bd99382b9e2118c66d79b68bfaddd9f647",
    "metadata": {},
    "name": "SpaceStarFavoriteSpaceMutation",
    "operationKind": "mutation",
    "text": "mutation SpaceStarFavoriteSpaceMutation($spaceKey:String!){favouriteSpace(spaceKey:$spaceKey){isSpaceFavourited}}"
  }
};
})();

(node as any).hash = "9ac5c6d950db28ef929151bfa7f1b419";

export default node;
